import React from "react"

import { arrayWithContents, isNumber } from "../../../utils"
import { rightPanelRegistration } from "../utils"
import DashLoader from "../../../widgets/DashLoader"
import {
  isLTPM,
  OperatorDisplay,
  getDate,
  RunCommentsIcons,
} from "../../../../components/shared_components_registration"
import { fillColors } from "../../../graphing/plotting/GraphComponents/ActionLayer"

const InfoSpan = ({ first = false, label, data }) => (
  <span style={first ? { marginBottom: "5px" } : {}}>
    <label style={{ margin: "0" }}>{`${label}:`}</label>
    <span>{data || "-"}</span>
  </span>
)

export default function RunCommentTable({
  fontPct = 80,
  currentReactor,
  loading,
  showTable,
  runActions,
  err,
  hadActions = false,
  onDash = false,
  isOperatorAction = false,
  intl,
}) {
  const registration = {
    noPreviousComments: () =>
      isLTPM ? intl.formatMessage({ id: "livedash.no.previous.comments" }) : "No previous comments",
    heightAdjustment: isLTPM ? (isOperatorAction ? 20 : 80) : 100,
    headerMap: [
      {
        // No label for priority as we just want to show an icon and edit button
        label: (_) => "",
        icon: true,
        colWidth: 1,
        className: "text-center",
        dataRow: (obj) => (
          <RunCommentsIcons obj={obj} intl={intl} currentReactor={currentReactor} fillColors={fillColors} />
        ),
      },
      {
        label: () =>
          isLTPM
            ? `${intl.formatMessage({ id: "general.date" })} + ${intl.formatMessage({
                id: "graphing.timelabel.day",
              })}`
            : `Date + Day`,
        icon: false,
        colWidth: 3,
        dataRow: (obj) => (
          <>
            <InfoSpan
              first={true}
              label={isLTPM ? `${intl.formatMessage({ id: "general.date" })}` : "Date"}
              data={getDate(obj.timestamp)}
            />
            <br />
            <InfoSpan
              label={isLTPM ? `${intl.formatMessage({ id: "graphing.timelabel.day" })}` : "Day"}
              data={isNumber(obj.day) ? obj.day.toFixed(2) : obj.day}
            />
          </>
        ),
      },
      {
        label: () =>
          isLTPM
            ? `${intl.formatMessage({ id: "general.action" })} + ${intl.formatMessage({
                id: "general.comment",
              })}`
            : `Action + Comment`,
        icon: false,
        colWidth: 5,
        dataRow: (obj) => (
          <>
            <InfoSpan
              first={true}
              label={isLTPM ? `${intl.formatMessage({ id: "general.action" })}` : "Action"}
              data={obj.action}
            />
            <br />
            <InfoSpan
              label={isLTPM ? `${intl.formatMessage({ id: "general.comment" })}` : "Comment"}
              data={obj.comment}
            />
          </>
        ),
      },
      {
        label: () => (isLTPM ? intl.formatMessage({ id: "general.operator" }) : "Operator"),
        icon: false,
        colWidth: 3,
        dataRow: (obj) => (
          <>
            <OperatorDisplay op={obj.actor} id={isLTPM ? "general.actor" : "Actor"} intl={intl} />
            {isLTPM && <br />}
            <OperatorDisplay op={obj.operator} id={isLTPM ? "general.operator" : "Operator"} intl={intl} />
          </>
        ),
      },
    ],
    ...rightPanelRegistration(isLTPM),
  }

  const colValueStyle = {
    fontSize: `${fontPct}%`,
    ...registration.colValueStyle,
  }

  return (
    <>
      <div className={"row"} style={{ ...registration.headerRowStyle, ...(onDash ? {} : { margin: "0" }) }}>
        {registration.headerMap.map((header, idx) => (
          <div
            className={`col-${header["colWidth"]}`}
            key={`run_comment_header_${idx}`}
            style={{ ...registration.headerColStyle, padding: "0 0 0 5px" }}
          >
            <p style={{ margin: "0px", fontSize: `${fontPct}%` }}>{header.label()}</p>
          </div>
        ))}
      </div>

      {err ? (
        <p style={{ marginTop: "10px", marginBottom: "20px" }} className={"error-message"}>
          {registration.errMsg(intl)}
        </p>
      ) : (
        <div
          style={{
            height: `calc(100% - ${registration.heightAdjustment}px)`,
            overflowY: "auto",
            overflowX: "hidden",
            position: "relative",
            ...(onDash ? { marginLeft: "-15px", marginRight: "-15px" } : {}),
          }}
        >
          {showTable ? (
            <>
              {loading ? (
                <div className={"dashed-black-border"} style={{ height: "100%" }}>
                  <DashLoader />
                </div>
              ) : (
                <>
                  {!arrayWithContents(runActions) && !hadActions ? (
                    <p style={{ marginTop: "25px", textAlign: "center" }}>
                      {registration.noPreviousComments()}
                    </p>
                  ) : (
                    <>
                      {runActions.map((action, i) => (
                        <div
                          key={`content_row_${i}`}
                          className={"row div-row"}
                          style={{
                            borderBottom: "1px solid var(--lanzalake-blue-bright)",
                            margin: "0",
                          }}
                        >
                          {registration.headerMap.map((column, idx) => (
                            <div
                              className={`col-${column["colWidth"]}`}
                              key={`comment_row_${i}_column_${idx}`}
                              style={{ padding: idx === 0 ? "0" : "0 0 0 5px", overflowWrap: "break-word" }}
                            >
                              <div
                                className={column.className || ""}
                                style={!column.icon ? colValueStyle : {}}
                              >
                                <span>{column.dataRow(action)}</span>
                              </div>
                            </div>
                          ))}
                        </div>
                      ))}
                    </>
                  )}
                </>
              )}
            </>
          ) : (
            <p style={{ marginTop: "25px", textAlign: "center" }}>{registration.noActiveRuns(intl)}</p>
          )}
        </div>
      )}
    </>
  )
}
